module.exports = __webpack_public_path__ + "static/media/omron.e3273aaa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/omron.gif
// module id = 333
// module chunks = 0